import gridPlus from '../../images/gridPlus.svg';
import { useTranslation } from 'react-i18next';

import './style.css';

// O componente Grid possui coisas especificas para plantas. Vou fazer esse mais generico, e a ideia será que ele seja substituido
const GeneralGrid = ({ items = [], onClickNew, onClickItem, hideCreateButton = false }) => {
  const { t } = useTranslation();

  return (
    <div className='gridContainer'>
      {(!hideCreateButton && onClickNew ? [
        <div
          className='gridItem growSlightly new'
          onClick={() => {
            onClickNew();
          }}
        >
          <div className='gridItemPlus'>
            <img src={gridPlus} />
          </div>
          <div className='gridItemText'>{t('create_item')}</div>
        </div>,
      ] : []).concat(
        items?.map((item, index) => {
          return (
            <div
              key={`gridItem-${index}`}
              className='gridItem growSlightly'
              onClick={() => {
                onClickItem(item);
              }}
            >
              {item.icon && <div className='gridItemIcon'>{item.icon}</div>}
              <div className='gridItemTitle'>{item?.name || item?.title}</div>
              <div className='gridItemDescription'>{item?.description}</div>
            </div>
          );
        }),
      )}
    </div>
  );
};
export default GeneralGrid;
